import { Injectable } from '@angular/core';

@Injectable()
export class TvScriptLoaderService {
  public loadScript(src: string, options: Record<string, string> = {}): Promise<void> {
    return new Promise((resolve, reject) => {
      if (options.id) {
        this._removeScript(options.id);
      }

      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = src;

      Object.keys(options).forEach((key) => script.setAttribute(key, options[key]));

      script.onload = () => resolve();
      script.onerror = (error: unknown) => reject(error);

      document.body.append(script);
    });
  }

  private _removeScript(elementId: string): void {
    const el = document.getElementById(elementId);

    if (el) el.remove();
  }
}
